import Vue from 'vue';

import CookieConsentPopup from '../ui/CookieConsentPopup.vue';

const mountCookieConsentPopup = (): void => {
    const mountNode = document.createElement('div');
    document.body.append(mountNode);

    new Vue({
        render: (h) => h(CookieConsentPopup),
    }).$mount(mountNode);
};

export default function initCookieConsentPopup(): void {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', mountCookieConsentPopup, { once: true });
    } else {
        mountCookieConsentPopup();
    }
}
